import {types} from './types';

export const setGetWithdrawalsAwaitingAction = (payload) => {
    return {
        type: types.SET_CARD_OPERATION,
        payload,
      }
}

export const setGetAlfakitBalanceAction = (payload) => {
  return {
    type: types.SET_GET_ALFAKIT_BALANCE,
    payload
  }
}